<template>
  <div class="nectar">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>Nectar CRM <small v-if="!activeIntegration">(Inativo)</small></h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="nectar"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com Nectar CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Nectar CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div
              v-if="hasError"
              class="alert alert-danger"
              role="alert">
              {{ Object.values(editErrors).join('/r') }}
            </div>
            <div v-if="activePbxIntegration">
              <p class="text-center">
                Para gerar/copiar seu Token
                <a
                  class="link"
                  href="https://app.nectarcrm.com.br/crm/crm/inicio#/configuracao/integracoes"
                  target="_blank">
                  clique aqui
                </a>
              </p>
              <div class="form-group row">
                <label
                  for="nectarToken"
                  class="col-sm-4 col-form-label">Token</label>
                <div class="col-sm-8">
                  <input
                    id="nectarToken"
                    type="text"
                    class="form-control"
                    v-model="token">
                </div>
              </div>
              <div v-if="configReady">
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Responsável</label>
                  <div class="col-sm-8">
                    <select
                      class="form-control"
                      id="userId"
                      v-model="userId">
                      <option
                        v-for="option in usersOptions"
                        :key="option.value"
                        :value="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Tipo de Ligação Atendida</label>
                  <div class="col-sm-8">
                    <select
                      class="form-control"
                      id="callTypeIdAnswered"
                      v-model="callTypeIdAnswered">
                      <option
                        v-for="option in callTypesOptions"
                        :key="option.value"
                        :value="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label">Tipo de Ligação não Atendida</label>
                  <div class="col-sm-8">
                    <select
                      class="form-control"
                      id="callTypeIdNotAnswered"
                      v-model="callTypeIdNotAnswered">
                      <option
                        v-for="option in callTypesOptions"
                        :key="option.value"
                        :value="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração com a Nectar CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Nectar CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialNectar"
      title="Tutorial Nectar CRM"
      video-url="https://www.youtube.com/embed/1-jo-spxzrk" />
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import NectarWrapper from '@/services/nectar-wrapper'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'

export default {
  name: 'IntegrationNectar',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      editErrors: null,
      integration: null,
      configReady: false,
      token: null,
      userId: null,
      callTypeIdAnswered: null,
      callTypeIdNotAnswered: null,
      usersOptions: [],
      contactsOptions: [],
      callTypesOptions: [],
      pbxIntegration: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
        .then(_ => {
          this.loadUsers()
          this.loadCallTypes()
          this.loadPbxIntegration()
        })
    })
  },
  methods: {
    loadIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=nectar`)
        .then(integrations => {
          this.integration = integrations.pop()
          if (this.integration && this.integration.metadata) {
            this.token = this.integration.metadata.token
            this.userId = this.integration.metadata.userId
            this.callTypeIdAnswered = this.integration.metadata.callTypeIdAnswered
            this.callTypeIdNotAnswered = this.integration.metadata.callTypeIdNotAnswered
          }
        })
    },
    loadPbxIntegration () {
      return loopback
        .get(`/integrations?filter[where][gateway]=sippulse`)
        .then(integrations => {
          this.pbxIntegration = integrations.pop()
          if (!this.pbxIntegration) {
            this.configReady = false
            this.editErrors = {
              missingParams: ['Integração Ramal precisa estar ativa']
            }
          }
        })
    },
    saveIntegration () {
      if (this.token && this.configReady) {
        this.editErrors = null
        const integrationParams = {
          gateway: 'nectar',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'nectar'
            }
          },
          metadata: {
            token: this.token,
            userId: this.userId,
            callTypeIdAnswered: this.callTypeIdAnswered,
            callTypeIdNotAnswered: this.callTypeIdNotAnswered,
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }
        if (this.integration) integrationParams.id = this.integration.id
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            this.integration = integration
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
          })
      } else {
        this.editErrors = {
          missingParams: ['Apikey é obrigatório']
        }
      }
    },
    toogleIntegration (event) {
      if (event.value === true) {
        this.editErrors = null
        this.loadPbxIntegration()
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.editErrors = null
      this.loadPbxIntegration()
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.token = null
          this.userId = null
          this.callTypeIdAnswered = null
          this.callTypeIdNotAnswered = null
          this.editErrors = null
          this.configReady = false
          this.usersOptions = []
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
    },
    loadUsers () {
      if (this.token) {
        NectarWrapper
          .getUsers(this.token)
          .then(users => {
            if (!this.userId && users[0]) {
              this.userId = users[0].id
            }
            this.usersOptions = []
            users.forEach(user => {
              this.usersOptions.push({
                value: user.id,
                text: user.nome
              })
            })
            this.configReady = true
            this.editErrors = null
          })
          .catch(_ => {
            this.userId = null
            this.usersOptions = []
            this.configReady = false
            this.editErrors = ['Token inválido']
          })
      }
    },
    loadCallTypes () {
      if (this.token) {
        NectarWrapper
          .getActiveCallTypes(this.token)
          .then(callTypes => {
            if (callTypes[0]) {
              if (!this.callTypeIdAnswered) this.callTypeIdAnswered = callTypes[0].id
              if (!this.callTypeIdNotAnswered) this.callTypeIdNotAnswered = callTypes[0].id
            }
            this.callTypesOptions = []
            callTypes.forEach(callType => {
              this.callTypesOptions.push({
                value: callType.id,
                text: callType.nome
              })
            })
            this.configReady = true
            this.editErrors = null
          })
          .catch(_ => {
            this.callTypeIdAnswered = null
            this.callTypeIdNotAnswered = null
            this.callTypesOptions = []
            this.configReady = false
            this.editErrors = ['Token inválido']
          })
      }
    },
    createAccessTokenNeverExpires () {
      return loopback
        .post('/users/accessTokens', { 'ttl': -1 })
        .then(token => token)
    },
    fetchAccessTokenNeverExpires () {
      return loopback
        .get('/users/accessTokens?filter[where][ttl]=-1')
        .then(tokens => {
          if (tokens && tokens.length > 0) {
            return tokens.pop()
          } else {
            return this.createAccessTokenNeverExpires()
          }
        })
    },
    openTutorial () {
      this.$refs.tutorialNectar.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'nectar'
    },
    activePbxIntegration () {
      return this.pbxIntegration &&
        this.pbxIntegration.gateway === 'sippulse' &&
        this.pbxIntegration.metadata &&
        this.pbxIntegration.metadata.username
    },
    hasError () {
      return this.editErrors && Object.keys(this.editErrors).length > 0
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    token: function (token) {
      if (token) {
        this.loadUsers()
        this.loadCallTypes()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Nectar.vue